document.addEventListener('DOMContentLoaded', function () {
    if (!document.cookie.includes('ageVerified=true')) {
        const ageModal = document.getElementById('age-gate-modal');
        ageModal.style.display = 'block';

        document.getElementById('age-yes').addEventListener('click', function () {
            document.cookie = "ageVerified=true; path=/";
            ageModal.style.display = 'none';
        });

        document.getElementById('age-no').addEventListener('click', function () {
            window.location.href = "https://google.com/";
        });
    }
});
